import { convertMarketplace } from 'actions/marketplace/MarketplaceConverter';
import { MarketplaceDto } from 'actions/marketplace/MarketplaceDtos';
import { MarketplaceError } from 'actions/marketplace/MarketplaceError';
import { ApiPublicClient } from 'api/ApiClient';
import { AxiosResponse } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { Marketplace } from 'types/Marketplace';
import {
    MARKETPLACE_ERROR_ACTION_TYPE,
    MARKETPLACE_FETCH_ACTION_TYPE,
    MARKETPLACE_FETCH_SUCCESS_ACTION_TYPE,
    MarketplaceAction
} from './MarketplaceActionsTypes';

const marketplacesUrl = '/marketplace_lookup';

const errorHandler = (error: unknown): MarketplaceAction => {
    console.error(error);

    return {
        type: MARKETPLACE_ERROR_ACTION_TYPE
    };
};

export const fetchMarketplaceBySlugThunk = (
    slug: string
): ThunkAction<Promise<Marketplace>, RootState, null, RootAction> => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            const response: AxiosResponse<MarketplaceDto> = await ApiPublicClient.get(
                marketplacesUrl,
                {
                    params: {
                        url_slug: slug
                    }
                }
            );

            const marketplace = convertMarketplace(response.data);

            dispatch(fetchSucces(marketplace));
            return marketplace;
        } catch (error) {
            dispatch(errorHandler(error));

            throw new MarketplaceError();
        }
    };
};

const fetchStart = (): MarketplaceAction => {
    return {
        type: MARKETPLACE_FETCH_ACTION_TYPE
    };
};

export const fetchSucces = (marketplace: Marketplace): MarketplaceAction => {
    return {
        type: MARKETPLACE_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            marketplace
        }
    };
};
